// pdf.js is half a megabyte of module-init work that only PDF-rendering pages need, so
// it stays out of the entry bundles: webpack splits this `import()` into its own chunk,
// fetched the first time a page actually loads a PDF. Repeated calls reuse the same
// module, so the worker setup runs once no matter how many controllers ask.
export async function loadPdfjs() {
  const pdfjsLib = await import("pdfjs-dist")
  // The worker ships with the app instead of coming from a CDN. Three reasons: its version
  // can never drift from the library's (a hand-written CDN URL silently outlives a `yarn
  // upgrade`), PDFs keep working on a network where a third-party CDN is blocked or down —
  // which today would break every PDF surface in the app at once — and pdf.js can actually
  // run in system specs, which is what lets the flipbook's memory ceiling be tested at all.
  // Webpack emits the file next to the bundles; `import.meta.url` resolves it to the
  // digested URL Propshaft serves verbatim.
  pdfjsLib.GlobalWorkerOptions.workerSrc =
    new URL("pdfjs-dist/build/pdf.worker.min.js", import.meta.url).href
  return pdfjsLib
}
